import { Fragment, useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ProfileComponent from "components/profile/Profile.component";
import { logout } from "store/user.store";
import { Loading } from "components/common";


const ProfileContainer = (props) => {
    const navigate = useNavigate();

    const [selectedIndex, setSelectedIndex] = useState(-1);
    const dispatch = useDispatch();
    const { loading, user } = useSelector((state) => state.user);

     const [open, setOpen] = useState(false);

    /**
     * anchorRef is used on different components and specifying one type leads to other components throwing an error
     * */
    const anchorRef = useRef(null);

    const handleLogout = useCallback(() => {
        dispatch(logout());
        // eslint-disable-next-line
    }, []);

    const handleClose = useCallback((event) => {
        if (anchorRef.current && anchorRef.current.contains(event.target)) {
            return;
        }
        setOpen(false);
        // eslint-disable-next-line
    }, []);

    const handleListItemClick = (event, index, route = "") => {
        setSelectedIndex(index);
        handleClose(event);
        if (route && route !== "") {
            navigate(route);
        }
    };
    const handleToggle = () => {
        // const endpoint = Request.users.getUserDetail;
        // const setAction = userDetailSetObjectAction;
        // const errorAction = userDetailObjectErrorAction;
        // const id = user.userId;
        // dispatch(
        //     userDetailGetObjectAction({ id, token, endpoint, setAction, errorAction })
        // );
        setOpen((prevOpen) => !prevOpen);
    };

    const prevOpen = useRef(open);
    useEffect(() => {
        if (prevOpen.current === true && open === false) {
            anchorRef.current.focus();
        }
        prevOpen.current = open;
    }, [open]);

    return (
        <Fragment>
            {loading && <Loading />}
            <ProfileComponent
                anchorRef={anchorRef}
                selectedIndex={selectedIndex}
                user={user}
                handleListItemClick={handleListItemClick}
                handleClose={handleClose}
                handleLogout={handleLogout}
                handleToggle={handleToggle}
                open={open}
               { ...props}
            />
        </Fragment>

    );
};

export default ProfileContainer;
